import { PayloadAction } from '@reduxjs/toolkit';
import { ICompany, ICompanyInitial } from './company.types';

export const actions = {
  setCurrentPage(state: ICompanyInitial, { payload }: PayloadAction<number>) {
    state.currentPage = payload;
  },
  setFilters(state: ICompanyInitial, { payload }: PayloadAction<{ search?: string; status?: string }>) {
    state.filters = {
      ...state.filters,
      ...payload,
    };
  },
  setCurrentCompany(state: ICompanyInitial, { payload }: PayloadAction<ICompany>) {
    state.currentCompany = {
      ...payload,
    };
  },
};
